import { render } from "./comHomeViewMob.vue?vue&type=template&id=50211d68"
import script from "./comHomeViewMob.vue?vue&type=script&lang=js"
export * from "./comHomeViewMob.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__